import { useRepo } from "pinia-orm";
import BaseMaterial from "@/models/SvcModels/Material";
import Agency from "@/models/SvcModels/Agency";
import { useUserStore } from "@/store/modules/user";

export default class Material extends BaseMaterial {
  static entity = "materials";
  static primaryKey = "uuid";

  static fields() {
    return {
      ...super.fields(),
      agencyUuid: this.attr(""),
      agencyCode: this.attr(""),
      agency: this.belongsTo(Agency, "agencyUuid"),
      locality: this.attr(""),
      packs: this.attr(null),
      typologies: this.attr(null),
      designation: this.string(""),
      company: this.attr(null),
    };
  }

  static async beforeCreate(model) {
    if (model.agencyUuid) {
      const AgencyRepo = useRepo(Agency);
      const agencyExist = AgencyRepo.where("uuid", model.agencyUuid).first();

      if (!agencyExist) {
        try {
          const userStore = useUserStore();
          await userStore.fetchAgencyByUuid(model.agencyUuid);
        } catch (e) {
          console.error(e);
        }
      }
    }
  }
}
